"use client"
import { useEffect } from "react"
import { useConsent } from "react-hook-consent"

export const MetaPixel = () => {
  const consent = useConsent()
  const allowedMeta = consent.hasConsent("meta")

  useEffect(() => {
    if (!allowedMeta) return
    if (window.fbq) return
    ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = "2.0"
      n.queue = []
      t = b.createElement(e)
      t.async = true
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js")
    window.fbq("init", "1223297045804611")
    window.fbq("track", "PageView")
  }, [allowedMeta])

  if (!allowedMeta) return null

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src="https://www.facebook.com/tr?id=1223297045804611&ev=PageView&noscript=1"
        alt="Meta Pixel"
      />
    </noscript>
  )
} 